export default __webpack_public_path__ + "static/media/jdwebsite.986505e4.png";